import { render } from "./sensor.vue?vue&type=template&id=c72ff514"
import script from "./sensor.vue?vue&type=script&lang=js"
export * from "./sensor.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__